import { Box, Container, Paper, Rating, Typography } from "@mui/material";
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import client1 from "../../images/client-1.png";
import client2 from "../../images/client-2.png";
import client3 from "../../images/client-3.png";
import client4 from "../../images/client-4.png";
import leftArrow from "../../images/left-arrow.png";
import rightArrow from "../../images/right-arrow.png";

const testimonials = [
  {
    id: "1",
    name: "Denny Hilguston",
    userId: "@denny.hil",
    img: client1,
    title: "Modern look & trending design",
    review:
      "Get working experience to work with this amazing team & in future want to work together for bright future projects and also make deposit to freelancer.",
    star: 4,
  },
  {
    id: "2",
    name: "Denny Hilguston",
    userId: "@denny.hil",
    img: client2,
    title: "Design Quality & performance",
    review:
      "Get working experience to work with this amazing team & in future want to work together for bright future projects and also make deposit to freelancer.",
    star: 4,
  },
  {
    id: "3",
    name: "Denny Hilguston",
    userId: "@denny.hil",
    img: client3,
    title: "Layout and organized layers",
    review:
      "Get working experience to work with this amazing team & in future want to work together for bright future projects and also make deposit to freelancer.",
    star: 4,
  },
  {
    id: "4",
    name: "Denny Hilguston",
    userId: "@denny.hil",
    img: client4,
    title: "Layout and organized layers",
    review:
      "Get working experience to work with this amazing team & in future want to work together for bright future projects and also make deposit to freelancer.",
    star: 4,
  },
  {
    id: "5",
    name: "Denny Hilguston",
    userId: "@denny.hil",
    img: client4,
    title: "Modern look & trending design",
    review:
      "Get working experience to work with this amazing team & in future want to work together for bright future projects and also make deposit to freelancer.",
    star: 4,
  },
];

// slider next prev
const PreviousBtn = (props) => {
  const { onClick } = props;
  return (
    <div className={"PreviousArrow"} onClick={onClick}>
      <img src={leftArrow} alt="" />
    </div>
  );
};
const NextBtn = (props) => {
  const { onClick } = props;
  return (
    <div className={"NextArrow"} onClick={onClick}>
      <img src={rightArrow} alt="" />
    </div>
  );
};

const Testimonial = () => {
  // slider
  const settings = {
    dots: false,
    infinite: false,
    lazyLoad: true,
    adaptiveHeight: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: <NextBtn />,
    prevArrow: <PreviousBtn />,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          // initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div>
      <Container sx={{ py: 12 }}>
        <Box sx={{ textAlign: "center" }}>
          <Typography className="sub-title" variant="subtitle1">
            Testimunial
          </Typography>
          <Typography className="section-title" variant="h3">
            Meet Client Satisfaction
          </Typography>
        </Box>
        <Box sx={{ mt: 8 }}>
          <Slider {...settings}>
            {testimonials.map((testimonial) => (
              <Paper
                className="testimonial-box"
                sx={{ boxShadow: 0, px: 2, py: 4, height: 1, my: 4 }}
                key={testimonial.id}
              >
                <Rating name="read-only" value={testimonial.star} readOnly />
                <Typography
                  sx={{ fontSize: 16, fontWeight: 700, my: 2 }}
                  variant="h5"
                >
                  {testimonial.title}
                </Typography>
                <Typography variant="body1">{testimonial.review}</Typography>
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 3, my: 2 }}
                >
                  <img src={testimonial.img} alt="" />
                  <Box>
                    <Typography
                      sx={{ fontSize: 16, fontWeight: 700 }}
                      variant="h4"
                    >
                      {testimonial.name}
                    </Typography>
                    <Typography
                      sx={{ fontSize: 15, fontWeight: 500, color: "#25A0FF" }}
                      variant="h5"
                    >
                      {testimonial.userId}
                    </Typography>
                  </Box>
                </Box>
              </Paper>
            ))}
          </Slider>
        </Box>
      </Container>
    </div>
  );
};

export default Testimonial;
